import { render, staticRenderFns } from "./VContractRevision.vue?vue&type=template&id=6f5baae8&"
import script from "./VContractRevision.vue?vue&type=script&lang=js&"
export * from "./VContractRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports